import { makeStyles } from '@material-ui/core/styles';

export const programStyles = makeStyles((theme) => ({
  root: {
    fontFamily: 'Work Sans',

    '& .MuiSelect-root': {
      fontFamily: 'Work Sans',
    },
    '& .MuiSelect-select': {
      '& :focus': {
        backgroundColor: 'white',
      },
    },
    '& .Mui-selected': {
      backgroundColor: '#F4FAF8 !important',
      // '&:hover': {
      //   backgroundColor: 'green !important',
      // },
    },
    '& .MuiMenuItem-root': {
      fontFamily: 'Work Sans !important',
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #484850',
    },
  },
  divWrapperOverride: {
    paddingBottom: '32px',
  },
  divHeaderWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 10px',
    '& .MuiBox-root': {
      display: 'flex',
      alignItems: 'center',
      '& .MuiTypography-body2': {
        fontWeight: 600,
        marginLeft: '20px',
      },
    },
  },
  chipHolder: {
    marginTop: '16px',
    display: 'flex',
    // justifyContent:'space-between'
  },
  holder: {
    marginTop: '8px',
  },
  holder_single: {
    margin: '0 !important',
    display: 'flex',
    '&>:nth-child(1)': {
      fontWeight: 600,
    },
    '&>:nth-child(2)': {
      marginLeft: '10px',
    },
  },
  flexWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  weekController: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiGrid-item': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  formControl: {
    minWidth: 120,
  },
  tableRowStyle: {
    '&:nth-of-type(even)': {
      backgroundColor: '#F0F8F5 !important',
    },
    '&:hover': {
      backgroundColor: '#F5F5F5 !important',
    },
  },
  callTypeSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  distanceFromIcon: {
    marginLeft: '20px',
  },
  tableHeaderText: { fontSize: '1.4rem', fontWeight: '400' },

  bpm: {
    fontWeight: 700,
    color: '#000000',
    fontSize: '14px',
    fontFamily: 'anonymous-pro',
    marginTop: '-5px !important',
    marginBottom: '-5px !important',
  },
  bpmspan: {
    fontWeight: 600,
    color: '#c0c0c0',
    fontSize: '12px',
    paddingLeft: '4px',
    marginTop: '-5px !important',
    marginBottom: '-5px !important',
  },
}));
